import { CheckIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { animations, viewportConfig } from '../../config/animations';

const AvoprimeProduct = () => {
  const { t } = useTranslation();

  return (
    <section className='py-8 bg-gradient-to-br from-avoprime-primary/5 to-avoprime-secondary/5'>
      <div className='container mx-auto px-4 sm:px-6 lg:px-8'>
        {/* Header */}
        <motion.div
          {...animations.fadeInUp}
          whileInView={animations.fadeInUp.animate}
          viewport={viewportConfig}
          className='text-center mb-16'
        >
          <h2 className='text-4xl sm:text-5xl lg:text-6xl font-eras font-bold text-avoprime-primary mb-6'>
            {t('avoprimeProduct.title')}
          </h2>
          <p className='text-xl lg:text-2xl font-montserrat text-gray-700 max-w-4xl mx-auto leading-relaxed'>
            {t('avoprimeProduct.subtitle')}
          </p>
        </motion.div>

        {/* Content Grid */}
        <motion.div
          variants={animations.containerVariants}
          initial='hidden'
          whileInView='visible'
          viewport={viewportConfig}
          className='grid lg:grid-cols-2 gap-8 lg:gap-12'
        >
          {/* Advantages Card */}
          <motion.div
            variants={animations.itemVariants}
            className='bg-gradient-to-br from-avoprime-primary to-avoprime-secondary rounded-3xl p-8 lg:p-12 text-white shadow-2xl'
          >
            <h3 className='text-2xl lg:text-3xl font-eras font-bold mb-8'>
              {t('avoprimeProduct.advantages.title')}
            </h3>
            <ul className='space-y-6'>
              <li className='flex items-start space-x-4'>
                <CheckIcon className='w-6 h-6 text-avoprime-light mt-1 flex-shrink-0' />
                <span className='font-montserrat text-lg'>
                  {t('avoprimeProduct.advantages.texture')}
                </span>
              </li>
              <li className='flex items-start space-x-4'>
                <CheckIcon className='w-6 h-6 text-avoprime-light mt-1 flex-shrink-0' />
                <span className='font-montserrat text-lg'>
                  {t('avoprimeProduct.advantages.durability')}
                </span>
              </li>
              <li className='flex items-start space-x-4'>
                <CheckIcon className='w-6 h-6 text-avoprime-light mt-1 flex-shrink-0' />
                <span className='font-montserrat text-lg'>
                  {t('avoprimeProduct.advantages.quality')}
                </span>
              </li>
              <li className='flex items-start space-x-4'>
                <CheckIcon className='w-6 h-6 text-avoprime-light mt-1 flex-shrink-0' />
                <span className='font-montserrat text-lg'>
                  {t('avoprimeProduct.advantages.market')}
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Image Card */}
          <motion.div
            variants={animations.itemVariants}
            className='relative rounded-3xl overflow-hidden shadow-2xl h-80 lg:h-96'
          >
            <img 
              src='/hold-avocado.webp' 
              alt='Hold Avocado' 
              className='w-full h-full object-cover'
            />
            <div className='absolute inset-0 bg-gradient-to-t from-black/20 to-transparent' />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AvoprimeProduct;
